
export class ProdutoFiscalCadastroFormModel {
    constructor(
        public descricao: string = '',
        public cfop: string = '',
        public icmsCst: number = 0,
        public pisCst: number = 0,
        public cofinsCst: number = 0,
    ) { }
}